// ─── confirm dialog ────────────────────────────────────────────────────────

import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
  isPending?: boolean;
  confirmLabel?: string;
  confirmColor?: "error" | "primary";
}

export function ConfirmDialog(
  {
    open,
    title,
    message,
    onConfirm,
    onClose,
    isPending,
    confirmLabel = "Delete",
    confirmColor = "error",
  }: ConfirmDialogProps,
) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" color={confirmColor} disabled={isPending} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
